import { useSelector } from "react-redux";
import * as userSelectors from "store/selectors/user/userSelectors";

const HiddenIfReadOnly = ({ children }) => {
  const isUserReadOnly = useSelector(userSelectors.isUserReadOnly);
  return isUserReadOnly ? <></> : children;
};

export default HiddenIfReadOnly;
